import { Fragment } from 'react';
import { FiltersProvider } from '../../../components/providers/FiltersProvider';
import PageHeader from '../../../layout/shared/page-header';
import { menuRoutes } from '../../../router/menu';
import TutorIncidencesList from './TutorIncidencesList';

const TutorIncidencesListWrapper = () => {
    return (
        <Fragment>
            <FiltersProvider defaultFilterFilters={{ resolution_status: 'pending' }}>
                <PageHeader
                    title="Incidencias de tutor"
                    breadcrumb={[
                        { name: 'Administración' },
                        { name: 'Control de Errores' },
                        { name: 'Incidencias tutor', href: menuRoutes.incidences.path + menuRoutes.incidences.tutor },
                    ]}
                />
                <TutorIncidencesList />
            </FiltersProvider>
        </Fragment>
    );
};

export default TutorIncidencesListWrapper;
